import React from "react";
import { IntercomConversationApi } from "../../../../../../../../services/Api/Admin/adminTypes";
import ConversationAuthor from "./ConversationAuthor";
import ConversationAvatar from "./ConversationAvatar";
import ConversationAvatars from "./ConversationAvatars";
import ConversationContent from "./ConversationContent";
import OpenInIntercom from "./OpenInIntercom";

interface Props {
	conversation: IntercomConversationApi;
}

const OrganizationIntercomSingleConversation = ({ conversation }: Props) => {
	const author = conversation.source.author;
	return (
		<div className="intercom-conversation-wrapper">
			<div className="intercom-conversation">
				<ConversationAvatar avatar={conversation.main_avatar} />
				<ConversationAuthor createdAt={conversation.created_at} author={author} />
			</div>
			<div className="intercom-conversation-content">
				<ConversationContent updatedAt={conversation.updated_at} content={conversation.source} />
			</div>
			<div className="intercom-conversation-footer">
				<ConversationAvatars avatars={conversation.avatars.filter((av) => typeof av === "string")} />
				<OpenInIntercom
					totalCount={conversation.conversation?.total_count}
					intercomLink={conversation?.intercom_link}
				/>
			</div>
		</div>
	);
};

export default OrganizationIntercomSingleConversation;
